/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { AssetDashboard } from './pages/AssetDashboard'

export const AssetLayout: FC = () => <AssetDashboard />
